/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { usePlayerComponents } from "../../../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../../../shared/context/PlayerTranslationContext";
import SkipIcon from "../../../../../shared/icons/player/Next.svg";
import {
  usePlayerAdvertisementTracker,
  usePlayerController,
} from "../../../../BasePlayer";

export const SkipButton = () => {
  const { player } = usePlayerController();

  const {
    tracker: { skippable, skipTimeOffset, currentTime },
  } = usePlayerAdvertisementTracker();

  const { t } = usePlayerTranslation();
  const { Button } = usePlayerComponents();

  const [active, setActive] = useState<boolean>(false);

  const counter = useMemo(() => {
    return Math.round(Math.max(skipTimeOffset - currentTime, 0));
  }, [currentTime, skipTimeOffset]);

  const onClick = useCallback(() => {
    active && player.skipAd();
  }, [active, player]);

  useEffect(() => {
    const unsubscribe = player.onEvent("adskipallowed", () => {
      setActive(true);
    });

    return () => unsubscribe();
  }, [player]);

  if (!skippable) {
    return <></>;
  }

  return (
    <Button
      variant="secondary"
      onClick={onClick}
      aria-label={
        counter
          ? `${t("PLAYER_BUTTON_SKIP_AD")} ${counter}`
          : t("PLAYER_BUTTON_SKIP_AD")
      }
    >
      {!counter && <SkipIcon aria-hidden="true" focusable="false" />}
      {counter ? counter : t("PLAYER_BUTTON_SKIP_AD")}
    </Button>
  );
};
